var resources = require('items-view-strings');
    var strings = resources['_L4wZEz8IUd7SDua2IOO2PA'];
export { strings };
export default strings;
